<div class="wrapper">
  <button
    mat-button
    color="primary"
    class="team-expenses-name"
    [class.team-expenses-name-vertical]="!isVisible()"
    (click)="toggleVisibility()"
  >
    Расходы команды
  </button>
  @if (isVisible()) {
    <div
      class="team-expenses-content"
      @smoothShowHideWidth
    >
      <div class="team-expenses-month">
        {{ releaseCalendarSelectedOptions().monthName }}
      </div>
      <div class="calendar">
        <div class="calendar-header">
          @for (day of days; track $index) {
            <div class="day">
              {{ day }}
            </div>
          }
        </div>
        <div class="calendar-body">
          @for (day of totalDays(); track $index) {
            <div
              class="day"
              [class.day-empty]="day === 0"
            >
              @if (day !== 0) {
                <div class="day-number">
                  {{ day }}
                </div>
                @if (hasDataForDay(day)) {
                  <div class="day-price">
                    @for (expense of releaseCalendarTeamExpenses(); track $index) {
                      <div>
                        @if (isSameDay(expense, day)) {
                          <div>
                            {{ formatBudgetValue(expense.price) }} / {{ expense.count }}
                          </div>
                        }
                      </div>
                    }
                  </div>
                } @else {
                  <div class="day-price">
                    {{ formatBudgetValue(0) }}
                  </div>
                }
              }
            </div>
          }
        </div>
      </div>
    </div>
  }
</div>
